import Vue from 'vue';
import Vuex from 'vuex';
import voterModule from './modules/voter';
import electionModule from './modules/election';
import candidateModule from './modules/candidate';
import loginModule from './modules/login';
import voteModule from './modules/vote';
import voterRegistrationModule from './modules/voterRegistration';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    appVersion: process.env.VUE_APP_VERSION || 'N/A',
    pathElection: '',
    idElection: null,
    accessKey: '',
    passwordResetKey: '',
    loading: false,
    progressbarActive: false,
    loginCurrentStatePage: '',
    loginStatesPage: {
      Login: 'LOGIN',
      LoginAzureAD: 'LOGINAZUREAD',
      LoginWithoutPass: 'LOGINWITHOUTPASS',
      IsFirstAccess: 'ISFIRSTACCESS'
    },
    logout: null,
    showAlertManyVotes: false
  },
  getters: {},
  mutations: {
    setShowAlertManyVotes(state, value) {
      state.showAlertManyVotes = value;
    }
  },
  actions: {},
  modules: {
    voter: voterModule,
    election: electionModule,
    candidate: candidateModule,
    login: loginModule,
    vote: voteModule,
    voterRegistration: voterRegistrationModule
  }
});
